export default "__VITE_ASSET__0114b3ba__"